const NotFound = () => {
	return (
		<main id="not-found-page">
			<div id="container">
				<div>
					<div>
						<h1>404 Not Found</h1>
					</div>
				</div>
			</div>
		</main>
	);
};

export default NotFound;
